import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";

void serviceworker.unregister();

if (typeof window !== "undefined" && "caches" in window) {
	window.addEventListener("load", async () => {
		try {
			const keys = await caches.keys();
			await Promise.all(keys.map(key => caches.delete(key)));
		} catch (error) {
			console.warn("Falha ao limpar caches antigas do navegador:", error);
		}
	});
}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

const shouldEnableServiceWorker = process.env.REACT_APP_ENABLE_SW === "true";